import React from "react";
import Helmet from "react-helmet";
import { StaticQuery, graphql } from "gatsby";

function SEOHome() {
  return (
    <StaticQuery
      query={graphql`
        {
          site {
            siteMetadata {
              title
              description
              keywords
              siteUrl
              twAuthor
            }
          }
          featuredImage: file(
            absolutePath: { glob: "**/src/assets/logo/POLogo.png" }
          ) {
            childImageSharp {
              original {
                src
              }
            }
          }
        }
      `}
      render={data => {
        const meta = [];
        const metaTitle = data.site.siteMetadata.title;
        const metaDescription = `${data.site.siteMetadata.description} - ${data.site.siteMetadata.title}`;
        const ogUrl = data.site.siteMetadata.siteUrl
        const ogType = 'website'
        const image = `${ogUrl}/${data?.featuredImage?.childImageSharp?.original?.src}`

        let schema = {
          "@context": "https://schema.org",
          "@type": "NewsMediaOrganization",
          "name": metaTitle,
          "url": ogUrl,
          "description": metaDescription,
          "alternateName": "PO",
          "foundingDate": "1964-03-01",
          "sameAs":[
            "https://twitter.com/politicaobrera_",
            "https://facebook.com/PoliticaObrera",
            "https://instagram.com/PoliticaObrera_",
            "https://www.tiktok.com/@politicaobrera_",
            "https://www.youtube.com/politicaobrera"
          ],
          "logo":{
            "@type": "ImageObject",
            "url": image,
            "height": 137,
            "width": 300,
            "caption": "Logo de Política Obrera"
          }
        }
        const schemaAsString = JSON.stringify(schema, null, 2);
        
        return(
          <Helmet
            htmlAttributes={{
              lang: "es"
            }}
            title={metaTitle}
            link={
              [
                {
                  rel:"canonical",
                  href:ogUrl,
                }
              ]
            }
            meta={
              [
                {
                  name: "description",
                  content: metaDescription
                },
                {
                  name: "keywords",
                  content: data.site.siteMetadata.keywords
                },
                {
                  property: "og:site_name",
                  content: "Política Obrera"
                },                
                {
                  property: "og:type",
                  content: ogType
                },
                {
                  property: "og:title",
                  content: metaTitle
                },
                {
                  property: "og:description",
                  content: metaDescription
                },
                {
                  property: "og:url",
                  content: ogUrl
                },
                {
                  name: "twitter:creator",
                  content: data.site.siteMetadata.twAuthor
                },
                {
                  name: "twitter:title",
                  content: metaTitle
                },
                {
                  name: "twitter:description",
                  content: metaDescription
                }
              ]
              .concat(
                image
                ? [
                  {
                    property: "og:image",
                    content: image
                  },
                  {
                    property: "og:image:alt",
                    content: metaTitle
                  },                  
                  {
                    property: "og:image:width",
                    content: 300
                  },
                  {
                    property: "og:image:height",
                    content: 137
                  },
                  {
                    property: "og:image:url",
                    itemprop: "image",
                    content: image
                  },                      
                  {
                    property: "twitter:image",
                    content: image
                  },                      
                  {
                    name: "twitter:image:alt",
                    content: metaTitle
                  },                
                  {
                    name: "twitter:card",
                    content: "summary_large_image"
                  }
                ]
                : [
                  {
                    name: "twitter:card",
                    content: "summary"
                  }
                ]
                )
              .concat(meta)
            }
          >
            {
              schemaAsString && <script type="application/ld+json">{schemaAsString}</script>
            }
          </Helmet>
        );
      }}
    />
  );
}

export default SEOHome;
